/**
 * True for the body ``POST evaluation`` and ``POST summarization-evaluation`` return with HTTP 200 when the
 * backend itself failed (``_create_empty_response`` in ``backend/app/routes/evaluation_route.py``): no run
 * status and no metrics. An answer about a run that failed carries its ``distillation_status``.
 */
export function isEvaluationErrorAnswer(result) {
    return result?.success === false && result?.distillation_status == null;
}
